module.exports = __webpack_public_path__ + "static/media/skincare-prod1.54cbcae0.jpg";